<style scoped>
    @import url("../../../styles/smartControl/cardEditRGP.scss");
</style>

<template>
    <div class="box_cardEditRGP mt-2">

        <!-- Caixa de diálogo aberta após input de atualização -->
        <v-dialog v-model="flagDialog" max-width="250px">
            <div v-if="flagDialog && !flagLoading">
                <DialogMSG 
                v-if="flagDialog" 
                :msgFromFather="msgFromFather"
                @fromDialogMsg="flagDialog = false" 
                />
            </div>
        </v-dialog>

        <!-- LOADING -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="linhaZero" v-if="!flagDialog && !flagLoading">
            <v-chip class="ml-1" size="x-small" color="white">{{ 'Receita (' + currentRecipe.formula + ') em edição' }}</v-chip>
            <v-icon class="ml-1" size="32">mdi-pen</v-icon>
        </div>

        <div class="linhaUm mt-4" v-if="!flagDialog && !flagLoading">

            <div class="colUm">

                <div class="linhaForm">
                    <span class="tLinha">Nome da receita</span>
                    <v-divider vertical class="mx-1" style="height: 30px;"></v-divider>
                    <div class="elInput">
                        <v-text-field
                            v-model="currentRecipe.name"
                            class="w-100"
                            color="#1F7AB1"
                            bg-color="transparent"
                            variant="plain" 
                            :placeholder="currentRecipe.name"
                            rounded="sm"
                            density="compact"
                            hide-details
                            @update:modelValue="changeInfo()"
                        />
                    </div>
                </div>
                
                <div v-for="key in booleanKeys" :key="key" class="linhaForm">
                    <span class="tLinha">{{ key }}</span>
                    <v-divider vertical class="mx-1" style="height: 30px;"></v-divider>
                    <div class="elSelect">
                        <v-select
                            v-model="currentRecipe[key]"
                            :items="booleanOptions"
                            item-title="title"
                            item-value="value"
                            class="w-100"
                            color="#1F7AB1"
                            variant="plain"
                            bg-color="transparent"
                            density="compact"
                            hide-details
                            @update:modelValue="changeInfo()"
                        />
                    </div>
                </div>

                <div v-for="key in numericKeys" :key="key" class="linhaForm">
                    <span class="tLinha">{{ key }}</span>
                    <v-divider vertical class="mx-1" style="height: 30px;"></v-divider>
                    <div class="elInput">
                        <v-text-field
                            type="number"
                            v-model.number="currentRecipe[key]"
                            step="any"
                            class="w-100"
                            color="#1F7AB1"
                            bg-color="transparent"
                            variant="plain"
                            rounded="sm"
                            density="compact"
                            hide-details
                            @update:modelValue="changeInfo()"
                        />
                    </div>
                </div>

            </div>
        </div>

        <v-btn v-if="flagBtnEnd && !flagDialog && !flagLoading"
        @click="sendInfo()"
        :style="{'color':'green'}"
        >
            <span class="txt_btn_irrig">Atualizar</span>
        </v-btn>
        <span v-if="flagMSG" class="txt_btn_irrig">{{ msg }}</span>

    </div>
</template>

<script>
import axios from 'axios'
import DialogMSG from './DialogMSG.vue'

export default {
    props: ['recipe','tok'],

    components:{DialogMSG},

    data() {
        return {
            currentRecipe:null,
            flagBtnEnd:false,

            booleanKeys: ['ECControl', 'phControl'],

            booleanOptions: [
                { title: 'Ativado', value: true },
                { title: 'Desativado', value: false }
            ],

            numericKeys: [
                'idealEC',
                'relMaxEC',
                'idealPH',
                'relMinPH',
                'phAbsoluteAlarm',
                'ceAbsoluteAlarm',
                'fertilizer_0_percentage',
                'fertilizer_1_percentage',
                'fertilizer_2_percentage',
                'fertilizer_3_percentage',
                'fertilizer_4_percentage',
                'fertilizer_5_percentage',
                'fertilizer_6_percentage',
                'fertilizer_7_percentage',
                'fertilizer_8_percentage'
            ],

            // estrutural local
            flagLoading:false,
            msg:'',
            flagMSG:false,
            flagDialog:false,
            msgFromFather:'', // dialog
        }
    },

    methods: {

        getUpdates() {
            let updates = {}

            for (const key of Object.keys(this.currentRecipe)) {
                let value = this.currentRecipe[key]
                let original = this.recipe[key]

                if (this.numericKeys.includes(key)) {
                    if (value == null || String(value).trim() === '') {
                        throw new Error(`Preencha o campo ${key}`)
                    }

                    value = Number(String(value).replace(',', '.'))

                    if (!Number.isFinite(value)) {
                        throw new Error(`Valor inválido em ${key}`)
                    }

                    if (original != null && String(original).trim() !== '') {
                        original = Number(String(original).replace(',', '.'))
                    }
                }

                if (value !== original) {
                    updates[key] = value
                }
            }

            return updates
        },

        changeInfo() {
            this.flagMSG = false

            try {
                this.flagBtnEnd = Object.keys(this.getUpdates()).length > 0
            } catch (e) {
                this.flagBtnEnd = false
                this.msg = e.message
                this.flagMSG = true
            }
        },

        async sendInfo() {

            let updates

            try {
                updates = this.getUpdates()
            } catch (e) {
                this.msg = e.message
                this.flagMSG = true
                return
            }

            if (Object.keys(updates).length === 0) {
                this.msg = 'Nenhuma alteração identificada'
                this.flagMSG = true
                this.flagBtnEnd = false
                return
            }

            this.flagMSG = false
            this.flagLoading = true

            try {
                const headers = {
                    'Authorization': `Bearer ${this.$store.state.tox}`,
                    'Xilema-Auth': `Bearer ${this.tok}`, // rcv from props
                    'Content-Type': 'application/json'
                }
                let rotaBranch = '/postxrecipexbyxid'
                let params = {
                    "recipe_id": this.currentRecipe.formula, // ID
                    "updates": updates // OBJ
                }
                const rota = this.$store.state.pathAxiosBASE + rotaBranch
                const res = await axios.post(rota, params, {headers})
                const rcv = res.data.result ?? res.data
                console.log('rcv: ',rcv)
                if (rcv.error === false) { this.msgFromFather = 'Atualizado.'; this.flagBtnEnd = false }
                else { this.msgFromFather = 'Não foi possível atualizar. Tente novamente mais tarde.'}

            } catch (e) {
                console.log('[sendInfo] erro:', e.response?.data ?? e.message)
                this.msgFromFather = 'Não foi possível atualizar. Tente novamente mais tarde.'
            } finally {
                this.flagLoading = false
                this.flagDialog = true
            }
        },
    },

    created() {
        //this.currentRecipe = structuredClone(this.recipe)
        this.currentRecipe = JSON.parse(JSON.stringify(this.recipe))
    },
}
</script>

/*
                {
                    "formula": 10,
                    "name": 'teste nome',
                    "idealEC": '1.3',
                    "relMaxEC": '2.5',
                    "idealPH": '5.4',
                    "relMinPH": '5.0',
                    "phAbsoluteAlarm": '6.0',
                    "ceAbsoluteAlarm": '3.0',
                    "phControl": '',
                    "ECControl": '',
                    "ideal_incremental": '',
                    "fertilizer_0_percentage":0,
                    "fertilizer_1_percentage":0,
                    "fertilizer_2_percentage":0,
                    "fertilizer_3_percentage":0,
                    "fertilizer_4_percentage":0,
                    "fertilizer_5_percentage":0,
                    "fertilizer_6_percentage":0,
                    "fertilizer_7_percentage":0,
                    "fertilizer_8_percentage":0,
                }
*/